import { QueryStatus, useQuery } from '@tanstack/react-query';
import fetchSite from './fetchSite';
import { Site } from '../CommonTypes';
import { useParams } from 'react-router-dom';

export default function useSite() {
  const { company, sitename } = useParams();
  const enabled = Boolean(company && sitename);

  const results = useQuery({
    queryKey: ['site', sitename, 'company', company],
    queryFn: () => fetchSite(sitename!, company!),
    enabled, // only run if both params exist
  });

  if (results.data === undefined) {
    return [{}, results.status] as [Site, QueryStatus];
  } else {
    const site = { ...results.data[0], company };
    return [site, results.status] as [Site, QueryStatus];
  }
}
